var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { joiResolver } from '@hookform/resolvers/joi';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@interfaces/keychain.interface';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { navigateTo, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { ResourceItemComponent } from '@popup/steem/pages/app-container/home/resources-section/resource-item/resource-item.component';
import { SavingOperationType } from '@popup/steem/pages/app-container/home/savings/savings-operation-type.enum';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import { FavoriteUserUtils } from '@popup/steem/utils/favorite-user.utils';
import { SavingsUtils } from '@popup/steem/utils/savings.utils';
import TransferUtils from '@popup/steem/utils/transfer.utils';
import Joi from 'joi';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { ComplexeCustomSelect } from 'src/common-ui/custom-select/custom-select.component';
import { FormContainer } from 'src/common-ui/form-container/form-container.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { FormInputComponent } from 'src/common-ui/input/form-input.component';
import { InputType } from 'src/common-ui/input/input-type.enum';
import { Separator } from 'src/common-ui/separator/separator.component';
import { Screen } from 'src/reference-data/screen.enum';
import { FormUtils } from 'src/utils/form.utils';
import FormatUtils from 'src/utils/format.utils';
const rules = FormUtils.createRules({
    username: Joi.string().required(),
    amount: Joi.number().required().positive().max(Joi.ref('$maxAmount')),
});
const SavingsPage = ({ currencyLabels, paramsSelectedCurrency, activeAccount, globalProperties, formParams, localAccounts, navigateToWithParams, navigateTo, setSuccessMessage, setErrorMessage, addToLoadingList, removeFromLoadingList, setTitleContainerProperties, }) => {
    const { control, handleSubmit, setValue, watch } = useForm({
        defaultValues: {
            username: formParams.username ? formParams.username : activeAccount.name,
            amount: formParams.amount ? formParams.amount : '',
            currency: formParams.currency
                ? formParams.currency
                : paramsSelectedCurrency,
            type: formParams.type
                ? formParams.type
                : SavingOperationType.DEPOSIT,
        },
        resolver: (values, context, options) => {
            const resolver = joiResolver(rules, {
                context: { maxAmount: maxAmount },
                errors: { render: true },
            });
            return resolver(values, { maxAmount: maxAmount }, options);
        },
    });
    const [text, setText] = useState('');
    const [savings, setSavings] = useState('...');
    const [liquid, setLiquid] = useState('...');
    const [savingsPendingWithdrawalList, setSavingsPendingWithdrawalList] = useState([]);
    const [totalPendingValue, setTotalPendingValue] = useState();
    const [autocompleteFavoriteUsers, setAutocompleteFavoriteUsers] = useState({ categories: [] });
    const [maxAmount, setMaxAmount] = useState(0);
    const currencyOptions = [
        { label: currencyLabels.steem, value: 'steem' },
        { label: currencyLabels.sbd, value: 'sbd' },
        { label: currencyLabels.hive, value: 'hive' },
        { label: currencyLabels.hbd, value: 'hbd' },
        { label: currencyLabels.blurt, value: 'blurt' },
        { label: currencyLabels.time, value: 'time' },
    ];
    const savingOperationTypeOptions = [
        {
            label: getMessage(SavingOperationType.WITHDRAW),
            value: SavingOperationType.WITHDRAW,
        },
        {
            label: getMessage(SavingOperationType.DEPOSIT),
            value: SavingOperationType.DEPOSIT,
        },
    ];
    useEffect(() => {
        loadAutocompleteFavoriteUsers();
        setTitleContainerProperties({
            title: 'popup_html_savings',
            isBackButtonEnabled: true,
            titleParams: [currencyLabels[watch('currency')]],
        });
    }, [watch('currency')]);
    useEffect(() => {
        if (activeAccount.account.savings_withdraw_requests > 0) {
            fetchCurrentWithdrawingList();
        }
        const sbdSavings = FormatUtils.toNumber(activeAccount.account.savings_sbd_balance);
        const steemSavings = FormatUtils.toNumber(activeAccount.account.savings_balance);
        const sbd = FormatUtils.toNumber(activeAccount.account.sbd_balance);
        const steem = FormatUtils.toNumber(activeAccount.account.balance);
        const liquidValue = watch('currency') === 'steem' ? steem : sbd;
        const savingsValue = watch('currency') === 'steem' ? steemSavings : sbdSavings;
        setLiquid(liquidValue);
        setSavings(savingsValue);
        setMaxAmount(watch('type') === SavingOperationType.DEPOSIT
            ? Number(liquidValue)
            : Number(savingsValue));
    }, [watch('currency')]);
    useEffect(() => {
        var _a;
        let text = '';
        if (watch('type') === SavingOperationType.DEPOSIT) {
            if (watch('currency') === 'sbd') {
                text = getMessage('popup_html_deposit_hbd_text', [
                    Number((_a = globalProperties.globals) === null || _a === void 0 ? void 0 : _a.sbd_interest_rate) / 100 + '',
                ]);
            }
        }
        else {
            text = getMessage('popup_html_withdraw_text');
        }
        setText(text);
    }, [watch('currency'), watch('type')]);
    useEffect(() => {
        if (typeof liquid === 'number' && typeof savings === 'number') {
            setMaxAmount(watch('type') === SavingOperationType.DEPOSIT
                ? Number(liquid)
                : Number(savings));
        }
    }, [watch('type')]);
    const fetchCurrentWithdrawingList = () => __awaiter(void 0, void 0, void 0, function* () {
        const savingsPendingWithdrawalList = yield SavingsUtils.getSavingsWithdrawals(activeAccount.name);
        const totalPendingValue = filterSavingsPendingWithdrawalList(savingsPendingWithdrawalList, currencyLabels[watch('currency')]).reduce((acc, curr) => acc + parseFloat(curr.amount.split(' ')[0]), 0);
        setTotalPendingValue(totalPendingValue !== 0 ? totalPendingValue : undefined);
        setSavingsPendingWithdrawalList(filterSavingsPendingWithdrawalList(savingsPendingWithdrawalList, currencyLabels[watch('currency')]));
    });
    const loadAutocompleteFavoriteUsers = () => __awaiter(void 0, void 0, void 0, function* () {
        setAutocompleteFavoriteUsers(yield FavoriteUserUtils.getAutocompleteListByCategories(activeAccount.name, localAccounts));
    });
    const handleButtonClick = (form) => {
        if ((watch('type') === SavingOperationType.DEPOSIT &&
            parseFloat(form.amount.toString()) > parseFloat(liquid.toString())) ||
            (watch('type') === SavingOperationType.WITHDRAW &&
                parseFloat(form.amount.toString()) > parseFloat(savings.toString()))) {
            setErrorMessage('popup_html_power_up_down_error');
            return;
        }
        let operationString = getMessage(watch('type') === SavingOperationType.WITHDRAW
            ? 'popup_html_withdraw_param'
            : 'popup_html_deposit_param', [currencyLabels[form.currency]]);
        const formattedAmount = `${parseFloat(form.amount.toString()).toFixed(3)} ${currencyLabels[watch('currency')]}`;
        const stringifiedAmount = `${FormatUtils.formatCurrencyValue(parseFloat(form.amount.toString()))} ${currencyLabels[watch('currency')]}`;
        let warning = TransferUtils.getTransferFromToSavingsValidationWarning(form.username, watch('type'));
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage(watch('type') === SavingOperationType.WITHDRAW
                ? 'popup_html_confirm_savings_withdraw'
                : 'popup_html_confirm_savings_deposit', [currencyLabels[watch('currency')]]),
            warningMessage: warning,
            skipWarningTranslation: true,
            title: operationString,
            skipTitleTranslation: true,
            fields: [
                { label: 'popup_html_value', value: stringifiedAmount },
                { label: 'popup_html_username', value: `@${form.username}` },
            ],
            formParams: getFormParams(),
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    let success;
                    switch (watch('type')) {
                        case SavingOperationType.DEPOSIT:
                            addToLoadingList('html_popup_deposit_to_savings_operation');
                            success = yield SavingsUtils.deposit(formattedAmount, form.username, activeAccount.name, activeAccount.keys.active, options);
                            break;
                        case SavingOperationType.WITHDRAW:
                            addToLoadingList('html_popup_withdraw_from_savings_operation');
                            success = yield SavingsUtils.withdraw(formattedAmount, form.username, activeAccount.name, activeAccount.keys.active, options);
                            break;
                    }
                    navigateTo(Screen.HOME_PAGE, true);
                    if (success) {
                        yield FavoriteUserUtils.saveFavoriteUser(form.username, activeAccount);
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else {
                            setSuccessMessage(watch('type') === SavingOperationType.DEPOSIT
                                ? 'popup_html_deposit_success'
                                : 'popup_html_withdraw_success', [stringifiedAmount]);
                        }
                    }
                    else {
                        setErrorMessage(watch('type') === SavingOperationType.DEPOSIT
                            ? 'popup_html_deposit_fail'
                            : 'popup_html_withdraw_fail', [watch('currency').toUpperCase()]);
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_deposit_to_savings_operation');
                    removeFromLoadingList('html_popup_withdraw_from_savings_operation');
                }
            }),
        });
    };
    const getFormParams = () => {
        return watch();
    };
    const setToMax = () => {
        if (watch('type') === SavingOperationType.WITHDRAW) {
            setValue('amount', Number(savings));
        }
        else {
            setValue('amount', Number(liquid));
        }
    };
    const goToPendingSavingsWithdrawal = () => {
        navigateToWithParams(Screen.PENDING_SAVINGS_WITHDRAWAL_PAGE, {
            savingsPendingWithdrawalList: filterSavingsPendingWithdrawalList(savingsPendingWithdrawalList, currencyLabels[watch('currency')]),
            currency: watch('currency'),
        });
    };
    const filterSavingsPendingWithdrawalList = (pendinSavingsWidrawal, currency) => {
        return pendinSavingsWidrawal.filter((pendingWithdrawItem) => pendingWithdrawItem.amount.split(' ')[1] === currency);
    };
    return (React.createElement("div", { className: "savings-page", "data-testid": `${Screen.SAVINGS_PAGE}-page` },
        React.createElement("div", { className: "resources" },
            React.createElement(ResourceItemComponent, { icon: SVGIcons.RESOURCE_ITEM_SAVINGS, label: "popup_html_savings_current", value: `${savings} ${currencyLabels[watch('currency')]}`, additionalClass: "blue" }),
            React.createElement(ResourceItemComponent, { icon: SVGIcons.RESOURCE_ITEM_WALLET, label: "popup_html_savings_available", value: `${liquid} ${currencyLabels[watch('currency')]}`, additionalClass: "red" })),
        totalPendingValue && totalPendingValue > 0 && (React.createElement("div", { className: "pending-savings-panel", onClick: goToPendingSavingsWithdrawal },
            React.createElement("div", { className: "pending-savings-text" }, getMessage('popup_html_pending_savings_withdrawal', [
                FormatUtils.formatCurrencyValue(totalPendingValue, 3),
                currencyLabels[watch('currency')],
            ])))),
        React.createElement(FormContainer, { onSubmit: handleSubmit(handleButtonClick) },
            text.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "text" }, text),
                React.createElement(Separator, { type: "horizontal", fullSize: true }))),
            React.createElement("div", { className: "form-fields" },
                React.createElement(ComplexeCustomSelect, { label: "popup_html_savings_operation_type", options: savingOperationTypeOptions, selectedItem: {
                        value: watch('type'),
                        label: getMessage(watch('type')),
                    }, setSelectedItem: (item) => setValue('type', item.value) }),
                React.createElement(FormInputComponent, { name: "username", control: control, dataTestId: "input-username", type: InputType.TEXT, logo: SVGIcons.INPUT_AT, placeholder: "popup_html_username", label: "popup_html_username", autocompleteValues: autocompleteFavoriteUsers }),
                React.createElement("div", { className: "amount-panel" },
                    React.createElement(ComplexeCustomSelect, { label: "popup_html_currency", options: currencyOptions, selectedItem: {
                            value: watch('currency'),
                            label: currencyLabels[watch('currency')],
                        }, setSelectedItem: (item) => setValue('currency', item.value) }),
                    React.createElement(FormInputComponent, { name: "amount", control: control, dataTestId: "amount-input", type: InputType.NUMBER, label: "popup_html_transfer_amount", placeholder: "0.000", skipPlaceholderTranslation: true, min: 0, rightActionClicked: setToMax, rightActionIcon: SVGIcons.INPUT_MAX }))),
            React.createElement(OperationButtonComponent, { dataTestId: "submit-savings", requiredKey: KeychainKeyTypesLC.active, label: watch('type') === SavingOperationType.WITHDRAW
                    ? 'popup_html_withdraw_param'
                    : 'popup_html_deposit_param', labelParams: [
                    currencyLabels[watch('currency')],
                ], onClick: handleSubmit(handleButtonClick) }))));
};
const mapStateToProps = (state) => {
    var _a, _b, _c;
    return {
        activeAccount: state.steem.activeAccount,
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
        powerType: state.navigation.stack[0].params.powerType,
        globalProperties: state.steem.globalProperties,
        paramsSelectedCurrency: state.navigation.stack[0].params
            .selectedCurrency,
        formParams: ((_b = state.navigation.stack[0].previousParams) === null || _b === void 0 ? void 0 : _b.formParams)
            ? (_c = state.navigation.stack[0].previousParams) === null || _c === void 0 ? void 0 : _c.formParams
            : {},
        localAccounts: state.steem.accounts,
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    navigateTo,
    setSuccessMessage,
    setErrorMessage,
    addToLoadingList,
    removeFromLoadingList,
    setTitleContainerProperties,
});
export const SavingsPageComponent = connector(SavingsPage);
